// Validation steps for disclosures (simpler than regular reports)
// Disclosures only have ONE review step instead of three
export const DISCLOSURE_VALIDATION_STEPS = [
    {
        key: 0,
        label: 'Disclosure Review',
        instruction:
            'Review the disclosure for completeness, accuracy, and compliance with requirements.',
    },
];
